"use client";

import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroHeader() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    title: "Hospitality",
    path: "/HospitalityPage"
  }, {
    title: "Services",
    path: "/ServicesPage"
  }, {
    title: "Legacy",
    path: "/LegacyPage"
  }, {
    title: "Connect",
    path: "/ConnectPage"
  }];
  return <section data-section-id="245501" id="hospitality-virtualization" className="relative min-h-screen flex flex-col bg-background text-foreground">
            {}
            <div className="absolute inset-0 z-0">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/hospitality_virtualization_heatmap.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/hospitality_virtualization_heatmap.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/hospitality_virtualization_heatmap.png-wvc-sizes" alt="Luxury hotel lobby with technical blue heat map overlay" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]"></div>
            </div>

            {}
            <div className="relative z-20 w-full px-6 py-6 flex justify-between items-center text-foreground max-w-[1200px] mx-auto">
                <Link to="/HomePage">
                    <img src="https://image-tc.galaxy.tf/wipng-7iri810bhntg4j3yuvgt0s4it/theselwyn-logo-white-ok.png?width=500" alt="IT Masters Logo" className="h-7 w-auto brightness-0 invert" />
                </Link>

                {}
                <nav className="hidden md:flex items-center gap-8">
                    {navLinks.map((link, i) => <Link key={i} data-index={i} to={link.path} className="text-sm font-mono font-medium tracking-widest hover:text-primary transition-colors uppercase">
                            {link.title}
                        </Link>)}
                </nav>

                <div className="hidden md:block">
                    <Button asChild variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md">
                        <Link to="/ConnectPage">Get Started</Link>
                    </Button>
                </div>

                {}
                <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-accent hover:text-accent-foreground" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu">
                    <Menu className="w-6 h-6" />
                </Button>
            </div>

            {}
            {isMobileMenuOpen && <div className="absolute inset-0 z-50 bg-background text-foreground flex flex-col">
                    <div className="px-6 py-6 flex justify-between items-center">
                        <Link to="/HomePage" onClick={() => setIsMobileMenuOpen(false)}>
                            <img src="https://image-tc.galaxy.tf/wipng-7iri810bhntg4j3yuvgt0s4it/theselwyn-logo-white-ok.png?width=500" alt="IT Masters Logo" className="h-7 w-auto brightness-0 invert" />
                        </Link>
                        <Button variant="ghost" size="icon" className="text-foreground hover:bg-accent hover:text-accent-foreground" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu">
                            <X className="w-6 h-6" />
                        </Button>
                    </div>
                    <nav className="flex flex-col items-center justify-center flex-1 gap-8 p-6">
                        {navLinks.map((link, i) => <Link key={i} data-index={i} to={link.path} className="text-3xl font-default tracking-tighter hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                                {link.title}
                            </Link>)}
                        <div className="mt-8 w-full max-w-xs" data-index="mobile-btn">
                            <Button asChild variant="secondary" className="w-full rounded-md" size="lg">
                                <Link to="/ConnectPage" onClick={() => setIsMobileMenuOpen(false)}>
                                    Get Started
                                </Link>
                            </Button>
                        </div>
                    </nav>
                </div>}

            {}
            <div className="relative z-10 flex-1 flex flex-col justify-center items-center text-center px-6 text-foreground max-w-4xl mx-auto">
                <h1 className="font-default text-5xl md:text-7xl lg:text-8xl mb-6 leading-tight tracking-tighter uppercase font-bold">
                    Mission Critical Virtualization
                </h1>
                <p className="font-default text-lg md:text-xl lg:text-2xl mb-10 max-w-2xl text-muted-foreground">
                    Architecting resilient VM infrastructure for global hospitality leaders. Powering guest services and back-office operations with zero downtime.
                </p>
                <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 text-lg px-10 py-6 h-auto rounded-md shadow-xl transition-all hover:scale-105">
                    <Link to="/ServicesPage">View Infrastructure</Link>
                </Button>
            </div>
        </section>;
}